import React, { Component } from 'react';
import {
  getDocCodeNameForPGA,
} from '../../../CBSA_App/components/entrySummaryForms/util';
import {
  get_DOCUMENT_TYPES_apx,
  get_SHIPMENT_DOCUMENTS_BY_DOCTYPE_apx,
  load_DIS_USER_REQUEST_apx,
  getSignedUrls,
  add_document_new_apx,
  add_document_status_apx,
  save_as_pdf_apx,
  search_DIS_DOC_CODES_apx,
  get_DIF_STATUS_apx,
  CREATE_DIS_USER_REQUEST_apx,
  submit_dis_request_apx,
  save_CBSA_DIF_FIELD_apx,
  submit_FILE_CBSA_DIF_REQUEST_apx,
  get_DIF_REQUEST_apx,
  create_MOCK_DIS_RESPONSE_apx,
  getURNumber,
  search_GET_DIF_DOC_TYPE_apx,
} from '../../../apiCalls/MainFormRequests';
import { getLatestResponse } from '../../../apiCalls/jobInfo';
import AddDocumentModal from '../../MainForm/components/AddDocumentModal.js';
import _ from 'lodash';
import './dc.css';
import DifContext from './DifContext';
import { DifModal } from './difModal';
export default class DocumentImageServicesChooser extends Component {
  constructor(props) {
    super();
    this.state = {
      showForm: false,
      doclistttt: {},
      currentImageIndex: 0,
      selectedDocuments_lo: [],
      doculistAsObjects: [],
      docTypes_zb: [],
      creatingpdf: false,
      submittingdis: false,
      creatingpdfstarttime: 0,
      currentpage: 'initial', //initial//pdfpage//final
      docstatesarray: [],
      nameofdocarray: [],
      nameofdocguesses: [],
      doclist_lg: [],
      pdfurl: '',
      disdonemessage: 'PDF Submitted!',
      awsbucketpdfurl: '',
      newdistoUse_bv: '',
      isChoosingaNewDoctype: false,
      zoomOutness:3,
      docCodeName: '',
      listOfSelectedDocuments: [],
      selectedDocType: '',
      cbpRequestId_m: '',
      pdfgenmessage: '',
      userRequestId_m: '',
      disvars: {},
      selectedDocId_p: 0,
      documentStatusList_ka: [],
      brokerComment: '',
      uploadDocStatuses: {},
      documentTypes: [],
      errorWarningsList: [],
      loadingShipmentList: [],
      selectedKxShipmentId: _.get(props,"engineBolRecords[1].intakeShipmentId") ||  props.shipId,
      
    };
  }

  addMoreDocs = () => {
    this.setState({
      doclist_lg: this.state.doclist_lg.concat({
        id: Math.random() + ' ' + Date.now(),
      }),
    });
  };
  createMock() {
    create_MOCK_DIS_RESPONSE_apx(this.state.userRequestId_m);
  }

  checkBoxStyle = {
    position: 'absolute',
    right: '2px',
    top: '18px',
    height: '15px',
    width: '15px',
  };

  saveDifPga = (field, value) => {
      save_CBSA_DIF_FIELD_apx(
        field,
        this.state.selectedDocType,
        value,
        this.props.shipmentCountry == 'CA' && this.props.pgaAutomation
          ? this.props.modalrequestid + this.props.pgaSubType
          : this.props.modalrequestid
      );
  };

  engineRecordsToKn = (engineRecords) =>{
    for(let oneRecord of (engineRecords||[])){
      if((oneRecord?.intakeShipmentId||"").indexOf("KN")==0)return oneRecord.intakeShipmentId;
      if((oneRecord?.shipmentId||"").indexOf("KN")==0)return oneRecord.shipmentId;
    }
    return null;
  }

  submit_difff = async () => {
    const { selectedKxShipmentId } = this.state;
    this.setState({
      creatingpdf: true,
      submittingdis: true,
    });
    let difrequestsArray = [];
    for (let onedoctype of this.state.selectedDocuments_lo) {
      this.setState({ creatingpdf: true });
      let filtereddocs = ((this.state.doclistttt||{})[selectedKxShipmentId] ||[]).filter((a) => {
        return a.documentType == onedoctype;
      });
      let documentList = [];
    let doculistAsObjects = [];

    for (let selectedDoc of this.state.selectedDocuments_lo) {
      for (let onedoc of (this.state.doclistttt||{})[selectedKxShipmentId]||[]) {
        if (selectedDoc == onedoc.documentType) {
          if((this.state.dontUseTheseDocIds||{})[onedoc.docid])continue;
          documentList.push(onedoc.docid);

          doculistAsObjects.push(onedoc);
        }
      }
    }

    this.setState({ doculistAsObjects: doculistAsObjects });

      this.setState({ pdfgenmessage: ' for ' + onedoctype });
      let failstate = setTimeout(() => {
        this.setState({
          creatingpdf: false,
          submittingdis: false,
          currentpage: 'initial',
        });
        alert('PDF CREATION FAILED?!');
        return;
      }, 35000);
      let pdfresponse = await save_as_pdf_apx(
        // this.props.shipId,
        selectedKxShipmentId ||this.props.shipId,
        documentList,
        onedoctype,
        this.engineRecordsToKn(this.props.engineBolRecords)
      );
      clearTimeout(failstate);
      let newbucketname = _.get(
        pdfresponse,
        'data.eventMessage.bucketName',
        null
      );
      let filenameX = _.get(pdfresponse, 'data.eventMessage.fileName', null);
      let fileSize = _.get(pdfresponse, 'data.eventMessage.fileSize', null);
      // let filenameX = filtereddocs[0].parentDocumentId
      // let fileSize = 0
      // let newbucketname = "kxr-attachments"
      if (!filenameX || !newbucketname) {
        this.setState({
          creatingpdf: false,
          currentpage: 'initial',
        });
        alert('PDF CREATION FAILED?!');
        return;
      }
      difrequestsArray.push({
        bucketName: newbucketname,
        key: filenameX,
        requestid:
          this.props.shipmentCountry == 'CA' && this.props.pgaAutomation
            ? this.props.modalrequestid + this.props.pgaSubType
            : this.props.modalrequestid, //specific to every modal!
        docType: onedoctype,
        fileSize: fileSize / (1024 * 1024),
      });
    }

    setTimeout(() => {
      submit_FILE_CBSA_DIF_REQUEST_apx(
        this.state.selectedKxShipmentId,
        difrequestsArray,
        this.props.importer.importerNo
      )
        .then((responseee) => {
          this.setState(
            {
              disdonemessage: _.get(
                responseee,
                'data.eventMessage.fieldmessage[0].fieldmessage', "FAIL"
              ),
              disdonestate: _.get(
                responseee,
                'data.eventMessage.fieldmessage[0].fieldmessagetype', 'SUCCESS'
              ),  
              creatingpdf: false,
              submittingdis: false,
              currentpage: 'final',
            },
            () => {
              this.props.getmaterialisedlpcodata();
            }
          );
        })
        .catch((err) => console.log('Api Error', err));
    }, 1000);
  };
  create_pdff = () => {
    const { selectedKxShipmentId } = this.state;
    if (this.state.creatingpdf) return;
    let documentList = [];
    let doculistAsObjects = [];

    for (let selectedDoc of this.state.selectedDocuments_lo) {
      for (let onedoc of (this.state.doclistttt||{})[selectedKxShipmentId]||[]) {
        if (selectedDoc == onedoc.documentType) {
          if((this.state.dontUseTheseDocIds||{})[onedoc.docid])continue;
          documentList.push(onedoc.docid);

          doculistAsObjects.push(onedoc);
        }
      }
    }

    this.setState({ doculistAsObjects: doculistAsObjects });

    if (documentList.length == 0) {
      alert('Select a document');
      return;
    }
    let uniquepdftime = Date.now();
    this.setState({ creatingpdf: true, creatingpdfstarttime: uniquepdftime });
    save_as_pdf_apx(
      this.state.selectedKxShipmentId,
      documentList,
      this.state.docCodeName,
      this.engineRecordsToKn(this.props.engineBolRecords)
    ).then(
      (pdfresponse) => {
        if (!pdfresponse.data.eventMessage) {
          alert('No pdf created! error! ' + JSON.stringify(pdfresponse.data));
          this.setState({ creatingpdf: false });
          return;
        }
        let pdfname = pdfresponse.data.eventMessage.fileName;
        this.setState({ awsbucketpdfurl: pdfname });
        let bucketName = pdfresponse.data.eventMessage.bucketName;

        // pdfname="KX-J2J1-2637_EPA04_20201103180331.pdf";
        getSignedUrls({ files: [bucketName + ':' + pdfname] }).then(
          (signedurlresponse) => {
            if (this.state.creatingpdfstarttime == uniquepdftime) {
              this.setState({ creatingpdf: false });
              for (let i of [2]) {
                //60000 //15000
                setTimeout(() => {
                  if (this.state.creatingpdfstarttime == uniquepdftime) {
                    this.setState({
                      showPDF: false,
                    });
                  }
                }, i * 5000 - 100);
                setTimeout(() => {
                  if (this.state.creatingpdfstarttime == uniquepdftime) {
                    this.setState({
                      showPDF: true,
                    });
                  }
                }, i * 5000);
              }
              this.setState({
                pdfurl: signedurlresponse.data.eventMessage.urls[0],
              });
              this.setState({ currentpage: 'pdfpage' });
              setTimeout(()=>{
                if(document.getElementById('loadingBarPDF')){
                  document.getElementById('loadingBarPDF').style.width = '100%';
                }
              },100);
              }
          }
        );
      },
      (timeouterrorProbably) => {
        alert(
          'Timeout when creating pdf :( ! Try selecting fewer pages? \n\n ' +
            JSON.stringify(timeouterrorProbably)
        );
        this.setState({ creatingpdf: false });
        this.setState({ currentpage: 'initial' });
      }
    );
  };

  submit_dis_requesttt = () => {
    this.setState({ submittingdis: true });

    submit_dis_request_apx(
      this.props.shipId,
      [this.state.awsbucketpdfurl],
      this.state.cbpRequestId_m,
      this.state.userRequestId_m,
      this.state.brokerComment
    ).then((disrequestdone) => {
      this.setState({ submittingdis: false });
      this.setState({ currentpage: 'final' });
      this.setState({
        disdonemessage: _.get(
          disrequestdone,
          'data.eventMessage.usDisGatewayResponseMessage',
          'No message'
        ),
      });
      this.setState({
        disdonestate: _.get(
          disrequestdone,
          'data.eventMessage.usDisGatewayResponseResult',
          'FAIL'
        ),
      });
    });
  };
  saveDIFValue = (fieldName, value) => {
    let oldstateBig = this.state.disvars;
    let oldstate = oldstateBig[this.state.selectedDocType];
    if (
      !!oldstate &&
      !!fieldName &&
      !!oldstate[fieldName] &&
      typeof oldstate[fieldName] == 'object'
    ) {
      let key = Object.keys(value)[0];
      oldstate[fieldName][key] = value[key];
    } else {
      if (!!oldstate && !!fieldName) {
        oldstate[fieldName] = value;
      }
    }
    this.setState({ disvars: oldstateBig }, () => {
      save_CBSA_DIF_FIELD_apx(
        fieldName,
        this.state.selectedDocType,
        value,
        this.props.shipmentCountry == 'CA' && this.props.pgaAutomation
          ? this.props.modalrequestid + this.props.pgaSubType
          : this.props.modalrequestid
      );
      try {
        // this.props.getmaterialisedlpcodata();
      } catch (e) {
        console.error('MISSING getmaterialisedlpcodata function!' + e);
      }
    });
    // this.props.getmaterialisedlpcodata(this.state.disvars)
  };

  reloadDocs = () => {
    const { selectedKxShipmentId } = this.state;
    get_SHIPMENT_DOCUMENTS_BY_DOCTYPE_apx(this.state.selectedKxShipmentId).then(
      (response) => {
        // debugger
        let myData=
        // this.props.shipmentCountry=='CA'? this.filterArray1ByArray2(response.data.eventMessage.documents,this.state.documentTypes):
        response.data.eventMessage.documents
        if (!myData) {
          return;
        }
        for (let docu of myData) {
          docu.documentType =docu.displayName || docu.documentType ;
        }
        let imagelist = [];
        let firsttime = true;
        for (let onedoc of myData) {
          if (firsttime) {
            this.selectdocumentType(
              onedoc.documentType,
              this.props.shipmentCountry
            );
          }
          firsttime = false;
          imagelist.push(onedoc.remoteurl.split('/').pop()); //only get the last part of the url
        }


        if (this.props.shipmentCountry == 'US') {//Remove Obsolete documents
          let mostRecentVersions = {}
          for(let doccc of myData||[]){
            if(!mostRecentVersions[doccc.documentType] || mostRecentVersions[doccc.documentType]<doccc.version){
              mostRecentVersions[doccc.documentType] = doccc.version;
            }
          }
          let obsoleteDocuments = {};
          for(let docccccc of (myData||[])){
            if(docccccc.isObsolete){
              obsoleteDocuments[docccccc.docid]=true;
              docccccc.documentType = "OBSOLETE";
            }
          }
          
          this.setState({mostRecentVersions, dontUseTheseDocIds:{...(this.state.dontUseTheseDocIds||{}),...obsoleteDocuments}})
        }//end Remove Obsolete documents
        
        this.setState({ doclistttt: {...this.state.doclistttt, [selectedKxShipmentId]: myData }});

        getSignedUrls({ files: imagelist }).then((response) => {
          this.setState({ imageurls: response.data.eventMessage.urls });
        });
      }
    );
  };
  fetchUrnForCA = async () => {
    if (this.props.shipmentCountry == 'CA') {
      const txNumber = window.transactionNumber.toString();
      let fillerCode = txNumber?.substring(0, 5);
      let valueOfURN =
        this.state.disvars[this.state.selectedDocType]?.identifier;
        this.saveDifPga('pga', this.props?.pgaType);
        this.saveDifPga('pgaSubProgramType', this.props?.pgaSubType);
      if (!valueOfURN) {
        let resp = await getURNumber(fillerCode, window.shipmentId);
        let response = await resp.data?.eventMessage?.txnNumber;

        this.saveDIFValue('identifier', response);
        
      }
    }
  };

  componentDidMount() {
    // debugger
    this.fetchDocumentTypes();
    setTimeout(()=> this.reloadDocs(),1500)

    getLatestResponse(this.state.selectedKxShipmentId, this.props.shipmentCountry).then(
      (response) => {
        this.setState({ headers_ll: response.data.eventMessage.fieldmessage });

        // this.setState({imageurls:response.data.eventMessage.urls})
      }
    );
    get_DOCUMENT_TYPES_apx(this.state.selectedKxShipmentId).then((response) => {
      this.setState({ docTypes_zb: response.data.eventMessage.docTypes });

      // this.setState({headers_ll:response.data.eventMessage.fieldmessage})
      //
      // this.setState({imageurls:response.data.eventMessage.urls})
    });
    if (this.props.shipmentCountry == 'CA') {
      get_DIF_STATUS_apx(this.state.selectedKxShipmentId, this.props.modalrequestid).then(
        (response) => {
          this.setState({
            documentStatusList_ka: _.get(
              response,
              'data.eventMessage.difStatus',
              []
            ),
          });
        }
      );
    }
    load_DIS_USER_REQUEST_apx(this.props.shipId).then((response) => {
      let docCodeName = _.get(
        response,
        'data.eventMessage.states.usDisUserRequestStates[0].docCode',
        ''
      );
      docCodeName = getDocCodeNameForPGA(docCodeName, window.currentPGA);
      this.setState({ docCodeName: docCodeName });
      let cpbid = _.get(
        response,
        'data.eventMessage.states.usDisUserRequestStates[0].cbpRequestId',
        ''
      );
      let userreqid = _.get(
        response,
        'data.eventMessage.states.usDisUserRequestStates[0].userRequestId',
        ''
      );
      if (!cpbid && this.props.shipmentCountry == 'US') {
        //We don't have a request from the CBP, so we need to create an UNSOLICITED request
        userreqid = 'N/A';
        CREATE_DIS_USER_REQUEST_apx(this.props.shipId).then((response) => {
          // console.log('CREATE_DIS_USER_REQUEST_apxresponse: ', response); //leave this for now...
          userreqid = _.get(
            response,
            'data.eventMessage.states.usDisUserRequestStates[0].userRequestId',
            ''
          );
          cpbid = 'UNSOLICITED';
          this.setState({ cbpRequestId_m: cpbid });
          this.setState({ userRequestId_m: userreqid });
        });
      } else {
        this.setState({ cbpRequestId_m: cpbid });
        this.setState({ userRequestId_m: userreqid });
      }
      if (docCodeName) {
        search_DIS_DOC_CODES_apx(docCodeName).then((response) => {
          this.setState({
            nameofdocarray: response.data.eventMessage.docCodeToDesc || [],
          });
        });
      }
      if (this.props.shipmentCountry == 'US') {
        this.disDocumentTypeSearchForCodes('');
      }
    });
  }

  componentWillUnmount() {
    window.currentPGA = 'NONE';
  }

  toggleDocumentType(onedoccname) {
    let oldarray = this.state.selectedDocuments_lo;
    if (oldarray.indexOf(onedoccname) >= 0) {
      oldarray.splice(oldarray.indexOf(onedoccname), 1);
    } else {
      oldarray.push(onedoccname);
    }
    this.setState({ selectedDocuments_lo: oldarray }, async () => {
     // (await window.shipmentCountry) === 'CA' && this.fetchUrnForCA();
      this.setState({ showForm: true });
    });

  }
  selectdocumentType(onedoccname, shipmentCountry) {
    this.setState({ showForm: false });
    this.setState({ selectedDocType: onedoccname }, async () => {
      this.setState({ showForm: true });
    });
    if (shipmentCountry == 'CA') {
      get_DIF_REQUEST_apx(
        onedoccname,
        this.props.pgaAutomation
          ? this.props.modalrequestid + this.props.pgaSubType
          : this.props.modalrequestid
      ).then((response) => {
        let disvarsstate = this.state.disvars;
        //disvarsstate[this.state.selectedDocType] = response.data.eventMessage;
        disvarsstate[onedoccname] = response.data.eventMessage;
        this.setState({
          disvars: disvarsstate,
        });
      }).then(async ()=>{
        (await window.shipmentCountry) === 'CA' && this.fetchUrnForCA();
      });
    }

    this.setState({ currentImageIndex: 0 });
  }
  selectdocumentId(onedocid) {
    this.setState({ selectedDocType: 'use__id' });
    this.setState({ selectedDocId_p: onedocid });
    this.setState({ currentImageIndex: 0 });
  }
  donewithdocumentType(onedoccname) {
    this.setState({
      listOfSelectedDocuments:
        this.state.listOfSelectedDocuments.concat(onedoccname),
    });
  }
  uploadFilesforDoc(documentobject) {
    let userBasicInfo = _.get(this.props, 'kxUser.userBasicInfo', {});
    new AddDocumentModal().fileUpload(
      [documentobject.files[0]],
      this.state.selectedKxShipmentId,
      this.props.kxUser,
      '0',
      false
    );
    setTimeout(() => {
      add_document_new_apx(
        this.state.selectedKxShipmentId,
        `${this.state.selectedKxShipmentId}-${documentobject.files[0].name}`,
        documentobject.doctype,
        userBasicInfo
      ).then((response) => {
        /*
          docStatusObject = {
            "noOfDocumentStillProcessing": 1,
            "processingDocuments": [
                "KX-A4I5-1600-samp2nssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss.pdf"
            ]
        }
        */
        let docStatusObject = response.data.eventMessage;
        let docid = _.get(docStatusObject, 'addDocumentObjectKey');
        let arrayofnumbers = Array(31)
          .fill()
          .map((x, i) => i);
        let hasOperationFailed =
          docid && (docid.resultOfOperation + '').toLowerCase() == 'fail';
        if (hasOperationFailed) {
          alert('FAIL: ' + docid.errorMsg);
        } else {
          for (let timeoutmult of arrayofnumbers) {
            setTimeout(() => {
              let uploadDocStatuses = this.state.uploadDocStatuses;
              if (
                !uploadDocStatuses[docid] ||
                uploadDocStatuses[docid].status == 'IN_PROGRESS'
              ) {
                add_document_status_apx(docid).then((response) => {
                  let docstatus = _.get(response, 'data.eventMessage[0]', {});
                  let oldstatus = uploadDocStatuses[docid] || {};
                  uploadDocStatuses[docid] = {
                    status: docstatus.status,
                    documentobject: documentobject,
                    counterx: (oldstatus.counterx || 0) + 1,
                  };
                  let timedout = uploadDocStatuses[docid].counterx >= 30;
                  documentobject.uploadStatus = timedout
                    ? 'Timed out'
                    : docstatus.status;
                  if (docstatus.status == 'SUCCESS' || timedout) {
                    this.reloadDocs();
                    documentobject.isDone = true;
                  } else if (docstatus.status == 'FAILURE') {
                    alert('UPLOAD FAILED!');
                  }
                  this.setState({ uploadDocStatuses });
                });
              }
            }, 8000 * (timeoutmult + 1));
          }
        }
        this.setState({ doclist_lg: this.state.doclist_lg });
      });
    }, 5500);
  }

  isDisabled = () => {
    if (
      this.state.errorWarningsList.length &&
      this.state.errorWarningsList.find(
        (err) => err.docType == this.state.selectedDocType
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  disDocumentTypeSearchForCodes = (value) => {
    if (!value || !value.trim()) value = 'CBP';
    value = value.trim();
    if (value.length < 3) value = 'CBP'; //api doesn't support < 3 character searches

    this.setState({ newdistoUse_bv: value });
    search_DIS_DOC_CODES_apx(value).then((response) => {
      let descriptionscleaned = [];
      for (let onethingy of response.data.eventMessage.docCodeToDesc || []) {
        descriptionscleaned.push({
          key: onethingy.key,
          id: onethingy.key,
          value: onethingy.value,
          description: onethingy.value,
        });
      }
      descriptionscleaned.sort((a, b) =>
        a.key.localeCompare(b.key, undefined, {
          numeric: true,
          sensitivity: 'base',
        })
      );
      if (this.state.newdistoUse_bv == value) {
        this.setState({
          nameofdocguesses: descriptionscleaned,
        });
      }
    });
  };
  // getFileLengthFlag = (file, country) => {
  //   /* We have implemented this function because we need to limit the size of DIF
  //    document as CBSA reject documents having size more than 3.9 MB */
  //   let flag = false;
  //   let fileSize = file[0].size;
  //   if (country === 'CA' && fileSize > 3.9e6) {
  //     flag = true;
  //     // alert(
  //     //   'The size of current pdf is greater than 3.9 MB , DIF document size cannot be greater than 3.9 MB as CBSA rejects it !'
  //     // );
  //     return flag;
  //   }
  //   return flag;
  // };


  componentDidUpdate(prevProps) {
    if (this.props.pgaType !== prevProps.pgaType || this.props.pgaSubType !== prevProps.pgaSubType) {
      this.fetchDocumentTypes();
    //  setTimeout(()=> this.reloadDocs(),1500)
    }
    
    const { selectedKxShipmentId } = this.state;
    if (!(this.state.doclistttt || {})[selectedKxShipmentId]) {
      if (!this.state.loadingShipmentList.includes(selectedKxShipmentId)) {
        this.setState({ loadingShipmentList: [...this.state.loadingShipmentList, selectedKxShipmentId] },()=>{
          this.reloadDocs()
        })
      }
    }
  }

  fetchDocumentTypes = () => {
    search_GET_DIF_DOC_TYPE_apx('', this.props.pgaType || '', this.props.pgaSubType || '')
      .then((response) => {
        const descriptionscleaned = response.data.eventMessage.docTypeForCode || [];
        const formattedData = descriptionscleaned.map((onethingy) => ({
          key: onethingy.documentCode,
          id: onethingy.documentCode,
          value: onethingy.documentType,
          description: onethingy.documentType,
        }));

        this.setState({
          documentTypes: formattedData,
        });
      });
  }

  filterArray1ByArray2(array1, array2) {
    const filteredArray1 = [];
// debugger
    for (const item1 of array1) {
        for (const item2 of array2) {
            if (item1.documentType
              === item2.id+" "+"-"+" "+item2.value || item1.displayName
              === item2.id+" "+"-"+" "+item2.value) {
                filteredArray1.push(item1);
                break; // Break the inner loop since we found a match
            }
        }
    }

    return filteredArray1;
}
  render() {
    const { selectedKxShipmentId } = this.state;
    let { docTypes_zb } = this.state;
    docTypes_zb = docTypes_zb || [];
    let doclistcombined = (this.state.doclistttt || {})[selectedKxShipmentId] ||[];

    let imageindex = 0;
    let numberofpagesbydoctype = {};

    for (let onedoc of doclistcombined) {
      if (this.state.imageurls) {
        onedoc.image = this.state.imageurls[imageindex];
        imageindex++;
      }
      numberofpagesbydoctype[onedoc.documentType] = numberofpagesbydoctype[
        onedoc.documentType
      ]
        ? numberofpagesbydoctype[onedoc.documentType] + 1
        : 1;
    }

    let nextprevbuttons = (
      <div>
        <button
          className='arrowButton'
          disabled={this.state.currentImageIndex <= 0}
          onClick={() =>
            this.setState({
              currentImageIndex: this.state.currentImageIndex - 1,
            })
          }
        >
          &lt;
        </button>
        &nbsp;&nbsp;{this.state.currentImageIndex + 1} of{' '}
        {numberofpagesbydoctype[this.state.selectedDocType]}&nbsp;&nbsp;
        {numberofpagesbydoctype[this.state.selectedDocType] && (
          <button
            className='arrowButton'
            disabled={
              this.state.currentImageIndex + 1 >=
              numberofpagesbydoctype[this.state.selectedDocType]
            }
            onClick={() =>
              this.setState({
                currentImageIndex: this.state.currentImageIndex + 1,
              })
            }
          >
            &gt;
          </button>
        )}
      </div>
    );
    let nameofdoc = '';

    let finddoc = this.state.nameofdocarray.find(
      (a) => a.key == this.state.docCodeName
    );
    if (finddoc && finddoc.value)
      nameofdoc = finddoc.key.trim() + ' - ' + finddoc.value.trim();
    let shipmentCountry = this.props.shipmentCountry;
    let requestSuccess = this.state.disdonestate === 'SUCCESS';
    let commentBox = (
      <>
        <textarea
          onChange={(event) => {
            this.setState({
              brokerComment: (event.target.value || '')
                .replaceAll(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/g, '')
                .toUpperCase(), //copied from AN
            });
          }}
          style={{ minWidth: '20vw', minHeight: '43px' }}
          value={this.state.brokerComment}
          maxLength='100'
        ></textarea>
      </>
    );
    return (
      <DifContext.Provider
        value={{
          setErrorList: (val) => this.setState({ errorWarningsList: val }),
          errorWarningsList: this.state.errorWarningsList,
          selectedKxShipmentId: this.state.selectedKxShipmentId,
          shipmentCountry: shipmentCountry,
          nameofdoc: nameofdoc,
          numberofpagesbydoctype: numberofpagesbydoctype,
          doclistcombined: doclistcombined,
          state: this.state,
          subType: this.props?.pgaSubType,
          commentBox: commentBox,
          engineBolRecords: this.props.engineBolRecords,
          reloadDocs: this.reloadDocs,
          nextprevbuttons: nextprevbuttons,
          requestSuccess: requestSuccess,
          setState: (data) => this.setState(data),
          disDocumentTypeSearchForCodes: (val) =>
            this.disDocumentTypeSearchForCodes(val),
          toggleDocumentType: (val) => this.toggleDocumentType(val),
          selectdocumentType: (a, b) => this.selectdocumentType(a, b),
          props: this.props,
          getFileLengthFlag: (a, b) => this.getFileLengthFlag(a, b),
          uploadFilesforDoc: (val) => this.uploadFilesforDoc(val),
          addMoreDocs: this.addMoreDocs,
          isDisabled: () => this.isDisabled(),
          donewithdocumentType: (val) => this.donewithdocumentType(val),
          saveDIFValue: (key, value) => this.saveDIFValue(key, value),
          checkBoxStyle: this.checkBoxStyle,
          submit_difff: () => this.submit_difff(),
          create_pdff: () => this.create_pdff(),
          submit_dis_requesttt: () => this.submit_dis_requesttt(),
          lpcoIssueDate:this.props.lpcoIssueDate
        }}
      >
        <DifModal />
      </DifContext.Provider>
    );
  }
}
